function NightAuditCounterReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">NightAuditCounterReport</div>
      </>
    );
  }
  
  export default NightAuditCounterReport;